<template>
    <div style="min-height: 80vh;">
      <div class="uk-padding-small uk-background-muted" >
        <div class="uk-container uk-container-small">
          <div id="toggleForm" >
            <h2 class="uk-text-center">Keyword Search </h2>
            <form  v-on:submit.prevent="searchKeyword(newKeyword)">
              <div uk-grid>
                <div class="uk-width-expand">
                  <div class="uk-search uk-search-large uk-width-1-1">
                    <span uk-search-icon></span>
                    <input class="uk-search-input" v-model="searchText" ref="searchText" type="search" placeholder="Search...">

                  </div>

                </div>
                <div class="uk-width-auto">
                  <button class="uk-button uk-button-large uk-text-center" type="submit" style="margin-top: 20px;"><b>Search</b></button>
                </div>
              </div>
              <div >
                <span v-for="item in letters" style=""><a href="#" style="font-size: large; padding-left: 3px; padding-right: 2px" @click="searchKeyword(item)">| {{item}} </a></span>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div class="uk-padding">
        <div class="uk-container uk-container-small">
          <div class="uk-padding-small">
            Search Results for: {{ newKeyword }}
          </div>
          <dl class="uk-description-list uk-description-list-divider" v-for="item in newResults">
            <dt>
              <a class=" uk-heading-bullet specHeading" href="#" style="color: rgb(197,179,88) !important;">{{ item.keyword }}</a>
            </dt>
            <dd><div v-for="axio in item.results" style="margin-left: 30px;">
                <a :href="axio.pageLink" class="uk-text-small">{{axio.pageName}} </a>
                <!--<p class="uk-text-small">{{axio.pageDescription}}</p>-->
                <hr style="margin-top: 5px !important; margin-bottom: 5px !important; ">
              </div>
            </dd>
            </dl>
         <!-- <ul uk-accordion>
            <li v-for="item in newResults">
              <a class="uk-accordion-title uk-heading-bullet specHeading" href="#" style="color: rgb(197,179,88) !important;">{{ item.keyword }}</a>
              <div class="uk-accordion-content">

              </div>
            </li>

          </ul>-->
        </div>
      </div>
    </div>
</template>

<script>
    export default {
        name: "keywordSearch",
        data(){
          return{
            searchText: null,
            letters: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H',
              'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P',
              'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'
            ],
            results: []
          }
        },
      methods: {
        searchKeyword: function (x) {
          this.$store.dispatch('getSearchResult',{
            keyword: x
          }).then(response => {
            console.log(response)
            for (let i = 0; i < response.data.Keyword.length; i++){
              this.results.push(response.data.Keyword[i])
            }
          })
        }
      },
      computed:{
        newKeyword: function () {
          return this.searchText
        },
        newResults: function () {
          return this.$store.state.KeywordResults
        }
      },
      mounted(){
        this.$refs.searchText.focus()
      }
    }
</script>

<style scoped>

</style>
